import { Tab } from '../../../../../views/customer-base';
import { BillingTypeOptions } from '../../../../../views/customer-base/BillingHealthTab';
import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tabs: {
    [Tab.Performance]: 'Suorituskyky',
    [Tab.NewCustomers]: 'Uudet ravintolat',
    [Tab.CustomerHealth]: 'Asiakkaan tila',
    [Tab.LiveAndInactive]: 'Live ja ei-aktiiviset',
    [Tab.BillingHealth]: 'Laskutuksen tila',
  },
  labels: {
    sales_manager: 'Myyntipäällikkö',
  },
  performance_tab: {
    table_columns: {
      name: 'Nimi',
      sales_manager: 'Myyntipäällikkö',
      orders: 'Tilaukset',
      sales: 'Myynti',
      previous_month_sales: 'Edellisen kuukauden liikevaihto',
    },
    labels: {
      sales_volume: 'Myyntimäärä:',
      all: 'Kaikki',
      click_to_sort: 'Napsauta lajitellaksesi',
      no_data: 'Ei tietoja',
    },
    toasts: {
      failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    },
  },

  new_restaurants_tab: {
    table_columns: {
      name: 'Nimi',
      sales_manager: 'Myyntipäällikkö',
      orders: 'Tilaukset',
      sales: 'Myynti',
      days_live: 'Live-päivät',
      early_performance: 'Varhainen suorituskyky',
    },
    labels: {
      click_to_sort: 'Napsauta lajitellaksesi',
      no_data: 'Ei tietoja',
      only_with_early_performance: 'Vain varhaisella suorituskyvyllä: ',
      early_performance_yes: '✔️ Kyllä',
      early_performance_no: '✗ Ei',
    },
    toasts: {
      failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    },
  },

  customer_health_tab: {
    titles: {
      sales_tiers: 'Myyntitasot',
      payments_ratio: 'Maksusuhde',
    },
    dataset_labels: {
      negative: 'Negatiivinen ({{values}})',
      ok: 'OK ({{values}})',
      good: 'Hyvä ({{values}})',
      excellent: 'Erinomainen ({{values}})',
    },

    companies_preview_modal: {
      title: 'Ravintoloiden esikatselu',
      table_columns: {
        name: 'Nimi',
        sales_manager: 'Myyntipäällikkö',
        orders: 'Tilaukset',
        sales: 'Myynti',
        total_payments: 'Maksut yhteensä',
        payments_ratio: 'Maksusuhde',
      },
      labels: {
        close: 'Sulje',
        click_to_sort: 'Napsauta lajitellaksesi',
        no_data: 'Ei tietoja',
      },
    },
    toasts: {
      failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    },
  },

  live_and_inactive_tab: {
    dataset_labels: {
      live: 'Live',
      no_orders: 'Ei tilauksia',
      no_conversion: 'Ei konversiota',
    },
    toasts: {
      failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    },
  },

  billing_health_tab: {
    filters: {
      billing_type: {
        label: 'Laskutustyyppi',
        options: {
          [BillingTypeOptions.Subscription]: 'Tilaus',
          [BillingTypeOptions.Manual]: 'Muu',
        },
      },
      high_risk_only: {
        label: 'Vain korkean riskin asiakkaat',
      },
    },
    fields: {
      name: 'Nimi',
      live_from: 'Live alkaen',
      billing_mode: {
        title: 'Laskutuslähde',
        options: {
          [BillingMode.Stripe]: 'Maksutapa',
          [BillingMode.InternalInvoicing]: 'Myynti',
        },
      },
      trial_ends_at: 'Kokeilun päättyminen',
      last_failed_invoice_amount: 'Viimeisimmän epäonnistuneen laskun summa',
      failed_payments_count: 'Epäonnistuneiden maksujen määrä',
    },
    tags: {
      is_high_billing_risk_customer: 'Korkea laskutusriski',
    },
    toasts: {
      failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    },
  },
};
